// reducer.js
import {
  RESUME_DATA_REQUEST,
  RESUME_DATA_SUCCESS,
  RESUME_DATA_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: [],
};

const getResumeDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESUME_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case RESUME_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case RESUME_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default getResumeDataReducer;
